import React from "react";
import {
  FabContainer,
  FabMessage,
  MessageIconStyled,
  CountBadgeContainer,
  CloseIconStyled,
  UnreadCount,
} from "./styles";
import { useSelector } from "react-redux";

function MessageFab(props) {
  const { showChatBox } = props;
  const unreadMessageCount = useSelector(
    (state) => state.user.unreadMessageCount
  );

  return (
    <FabContainer onClick={props.toggleChatBox}>
      <FabMessage aria-label="message" id={"chat-button"}>
        {showChatBox ? <CloseIconStyled /> : <MessageIconStyled />}
      </FabMessage>
      {unreadMessageCount > 0 && !showChatBox ? (
        <CountBadgeContainer>
          <UnreadCount>
            {unreadMessageCount > 10 ? "10+" : unreadMessageCount}
          </UnreadCount>
        </CountBadgeContainer>
      ) : null}
    </FabContainer>
  );
}

export default MessageFab;
